import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteAddress,
  getApi,
  getGeoData,
  getPinCodeAreas,
  getPinCodes,
  patchAddress,
  postAddresses,
} from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { DeleteIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import Spinner from "../../../common/Spinner";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import inputValidation from "../../../../utils/inputValidation";
import { toast } from "react-toastify";
import { useDialog } from "../../../../helpers/useDialog";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import axios from "axios";
import Select from "react-select";

const Address = () => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [erroeMsg, setErroeMsg] = useState({});
  const [currentUpdateId, setCurrentUpdateId] = useState("");
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [pinCodesData, setPinCodesData] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [areaName, setAreaName] = useState("");
  const [pinCode, setPinCode] = useState("");

  const [statesList, setStatesList] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [districtName, setDistrictName] = useState("");
  const [cityList, setCityList] = useState([]);
  const [city, setCity] = useState("");

  let options = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  };

  const {
    requestCall,
    auth,
    bhareeAdminBasicTable,
    addresses,
    countries,
    countryStates,
    countryStateCities,
    guestJWTToken,
  } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    // console.log("guestJWTToken: ", guestJWTToken);
    // console.log("guest_gwt_token", localStorage.guest_jwt_token);
    if (auth && !isEmpty(guestJWTToken) && !isEmpty(guestJWTToken?.data)) {
      setStatesList([]);
      setDistrictList([]);
      setCityList([]);
      setAreaData([]);

      getGeoDataDB().then((res) => {
        // console.log("After State Response: ", res);
        if (res?.success) {
          setStatesList(res?.data);
        } else {
          setStatesList([]);
        }
      });

      if (auth?.user?.register_state) {
        setStateName(auth?.user?.register_state);
      } else {
        setStateName("");
      }

      if (auth?.user?.register_district) {
        setDistrictName(auth?.user?.register_district);
      } else {
        setDistrictName("");
      }

      if (auth?.user?.register_city) {
        setCity(auth?.user?.register_city);
      } else {
        setCity("");
      }
    }
  }, [auth, guestJWTToken]);

  useEffect(() => {
    if (!isEmpty(stateName)) {
      onSelectValue("state", stateName);
      setDistrictList([]);
      setCityList([]);
      getGeoDataDB(stateName).then((res) => {
        console.log("After District Response: ", res);
        if (res.success) {
          setDistrictList(res.data);
        }
      });
    }
  }, [stateName]);

  useEffect(() => {
    if (!isEmpty(districtName) && !isEmpty(stateName)) {
      onSelectValue("district", districtName);
      setCityList([]);
      getGeoDataDB(stateName, districtName).then((res) => {
        console.log("After City Response: ", res);
        if (res.success) {
          setCityList(res.data);
        }
      });
    }
  }, [stateName, districtName]);

  useEffect(() => {
    if (!isEmpty(city) && !isEmpty(districtName) && !isEmpty(stateName)) {
      onSelectValue("city", city);
      setAreaData([]);
      getGeoDataDB(stateName, districtName, city).then((res) => {
        console.log("After Area Response: ", res);
        if (res.success) {
          setAreaData(res.data);
        }
      });
    }
  }, [stateName, districtName, city]);

  const getGeoDataDB = async (stateName, districtName, cityName) => {
    let apiURL = BHAREE_BASE_URL_LOCAL + "/api/geoDataDB?countryCode=IN";
    if (districtName) {
      apiURL += `&districtName=${encodeURIComponent(districtName)}`;
    }
    if (stateName) {
      apiURL += `&stateName=${encodeURIComponent(stateName)}`;
    }
    if (cityName) {
      apiURL += `&cityName=${encodeURIComponent(cityName)}`;
    }

    try {
      const res = await axios.get(apiURL, {
        headers: {
          ...options.headers,
          "x-guest-token": `${localStorage.guest_jwt_token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching geo data:", error);
    }
  };

 useEffect(() => {
  if (
    isCreateMode &&
    !isUpdateMode &&
    isEmpty(uploadFormObj?.full_name) &&
    auth?.user?.business_name
  ) {
    onSelectValue(
      "full_name",
      auth.user.business_name
    );
  }

  if (
    isCreateMode &&
    !isUpdateMode &&
    isEmpty(uploadFormObj?.primary_number) &&
    auth?.user?.mobile_number
  ) {
    onSelectValue(
      "primary_number",
      auth.user.mobile_number
    );
  }
}, [
  isCreateMode,
  isUpdateMode,
  uploadFormObj?.full_name,
  uploadFormObj?.primary_number,
  auth,
]);
  useEffect(() => {
    // onSelectValue(
    //   "state",
    //   FilterObjectsByKeyValue(countryStates?.data, "name", "Maharashtra")[0].name
    // );
    onSelectValue("country", FilterObjectsByKeyValue(countries?.data, "name", "India")[0].name);
    getApi("getAddressess", dispatch);
  }, [dispatch, countryStates, countries]);

  useEffect(() => {
    setIsCreateMode(false);
    setIsUpdateMode(false);
    if (isEmpty(addresses?.data) && addresses?.data?.length < 1) {
      setIsCreateMode(true);
    }
  }, [addresses]);

  // useEffect(() => {
  //   if (
  //     !isEmpty(uploadFormObj?.state) &&
  //     !isEmpty(countries?.data) &&
  //     !isEmpty(countryStates?.data)
  //   ) {
  //     getGeoData(
  //       dispatch,
  //       FilterObjectsByKeyValue(countries.data, "name", uploadFormObj?.country)[0].isoCode,
  //       FilterObjectsByKeyValue(countryStates.data, "name", uploadFormObj?.state)[0].isoCode
  //     );
  //   }
  // }, [uploadFormObj?.state, countries, countryStates, dispatch]);

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value);
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  const onSelectValueValidation = (key, value, maxLenght = 1000, numericOnly = false) => {
    setErroeMsg({});
    let updatedObj = {};
    let validate = inputValidation(value, maxLenght, numericOnly);
    if (validate.pass) {
      updatedObj[key] = validate.finalValue;
      setErroeMsg({ [key]: validate.msg });
      setUploadFormObj((previousVlaues) => ({
        ...previousVlaues,
        ...updatedObj,
      }));
    } else {
      setErroeMsg({ [key]: validate.msg });
    }
  };
const createUpdateAddress = (e) => {
  e.preventDefault();

  const formData = {
    ...uploadFormObj,
    user_id: auth?.user?.id,
  };

  console.log("**** Address form data ****", formData);

  if (
    !formData?.full_name ||
    !formData?.primary_number ||
    !formData?.city ||
    !formData?.state ||
    !formData?.pin_code ||
    !formData?.address_line_1 ||
    !formData?.address_type_id ||
    !formData?.area
  ) {
    toast.error("Please enter all the mandatory data.");
    return;
  }

  if (isUpdateMode) {
    patchAddress(
      currentUpdateId,
      formData,
      dispatch
    );
  } else {
    postAddresses(
      formData,
      dispatch
    );
  }
};

  const onSetUpdateObj = async (address) => {
    console.log("****** onSetUpdateObj ******", address);

    // await getGeoData(
    //   dispatch,
    //   FilterObjectsByKeyValue(countries.data, "name", address?.country)[0].isoCode,
    //   FilterObjectsByKeyValue(countryStates.data, "name", address?.state)[0].isoCode
    // );
    setUploadFormObj(address);
    setStateName(address?.state);
    setDistrictName(address?.district);
    setCity(address?.city);
    setAreaName(address?.area);
    setPinCode(address?.pin_code);

    setIsCreateMode(true);
    setIsUpdateMode(true);
    setCurrentUpdateId(address?.id);
    // displayPinCodes(address?.city);
    // displayPinCodeAreas(address?.pin_code);
  };

  // const displayPinCodes = async (city) => {
  //   setPinCodesData([]);
  //   const mPinCodesData = await getPinCodes(dispatch, city);
  //   if (mPinCodesData && mPinCodesData?.payload && mPinCodesData?.payload?.length > 0) {
  //     setPinCodesData(mPinCodesData?.payload);
  //   }
  // };

  // const displayPinCodeAreas = async (pincode) => {
  //   setAreaData([]);
  //   const mPinCodeAreas = await getPinCodeAreas(dispatch, pincode);
  //   if (mPinCodeAreas && mPinCodeAreas?.payload && mPinCodeAreas?.payload?.length > 0) {
  //     setAreaData(mPinCodeAreas?.payload);
  //   }
  // };
const handleAddNewAddress = () => {
  setIsCreateMode(true);
  setIsUpdateMode(false);
  setCurrentUpdateId("");
  setErroeMsg({});

  const savedAddresses = addresses?.data || [];

  // Get default address first.
  // If there is no default address, use the first address.
  const previousAddress =
    savedAddresses.find(
      (address) => address?.set_default === true
    ) || savedAddresses[0];

  // Get India
  const india =
    FilterObjectsByKeyValue(
      countries?.data || [],
      "name",
      "India"
    )[0]?.name || "India";

  if (previousAddress) {
    /*
     * A new address is being created.
     *
     * Copy all address details from the previous address.
     * Only address_type_id is cleared because the user
     * needs to select the new address type.
     */
    setUploadFormObj({
      full_name:
        previousAddress?.full_name ||
        auth?.user?.business_name ||
        "",

      primary_number:
        previousAddress?.primary_number ||
        auth?.user?.mobile_number ||
        "",

      alternate_number:
        previousAddress?.alternate_number || "",

      // IMPORTANT:
      // Do not copy old address type.
      address_type_id: undefined,

      address_line_1:
        previousAddress?.address_line_1 || "",

      address_line_2:
        previousAddress?.address_line_2 || "",

      address_line_3:
        previousAddress?.address_line_3 || "",

      country:
        previousAddress?.country || india,

      state:
        previousAddress?.state || "",

      district:
        previousAddress?.district || "",

      city:
        previousAddress?.city || "",

      area:
        previousAddress?.area || "",

      pin_code:
        previousAddress?.pin_code || "",

      // New address is not default initially.
      set_default: false,
    });

    // Set dropdown values
    setStateName(previousAddress?.state || "");
    setDistrictName(previousAddress?.district || "");
    setCity(previousAddress?.city || "");
    setAreaName(previousAddress?.area || "");
    setPinCode(previousAddress?.pin_code || "");

    // Clear old dropdown lists.
    // useEffect will load the correct lists again.
    setDistrictList([]);
    setCityList([]);
    setAreaData([]);
  } else {
    /*
     * No previous address exists.
     * Start with user's registered information.
     */
    setUploadFormObj({
      full_name:
        auth?.user?.business_name || "",

      primary_number:
        auth?.user?.mobile_number || "",

      alternate_number: "",

      address_type_id: undefined,

      address_line_1: "",
      address_line_2: "",
      address_line_3: "",

      country: india,

      state: "",
      district: "",
      city: "",
      area: "",
      pin_code: "",

      set_default: false,
    });

    setStateName("");
    setDistrictName("");
    setCity("");
    setAreaName("");
    setPinCode("");

    setDistrictList([]);
    setCityList([]);
    setAreaData([]);
  }
};
  const addressForm = (
    <>
      <Row className="m-0 form-row ">
        <Row className="m-0 px-0 w-full px-0  title-button-row">
          <h2>{!isUpdateMode ? "Create New Address" : "Update Address"}</h2>
          {addresses?.data?.length > 0 && (
            <CustomButton
              buttonClasses="view-switch-btn"
              onClick={() => {
                setIsCreateMode(false);
                setUploadFormObj({});
                setErroeMsg({});
              }}
            >
              {"List"}
            </CustomButton>
          )}
        </Row>
        <Form className=" modal-custom-class" onSubmit={createUpdateAddress}>
          <Row className="m-0">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Full name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
             <Form.Control
  type="text"
  required
  value={uploadFormObj?.full_name || ""}
  onChange={(e) =>
    onSelectValueValidation(
      "full_name",
      e.target.value,
      50
    )
  }
/>
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "full_name") && (
                    <p className="error-msg">{erroeMsg.full_name}</p>
                  )}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Primary number"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
               <Form.Control
  type="text"
  required
  value={uploadFormObj?.primary_number || ""}
  onChange={(e) =>
    onSelectValueValidation(
      "primary_number",
      e.target.value,
      10,
      true
    )
  }
/>
                
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "primary_number") && (
                    <p className="error-msg">{erroeMsg.primary_number}</p>
                  )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Alternate number"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.alternate_number || ""}
                  onChange={(e) =>
                    onSelectValueValidation("alternate_number", e.target.value, 10, true)
                  }
                />
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "alternate_number") && (
                    <p className="error-msg">{erroeMsg.alternate_number}</p>
                  )}
              </Form.Group>

     {!bhareeAdminBasicTable.loading &&
                !isEmpty(bhareeAdminBasicTable?.data?.addressTypes) &&
                bhareeAdminBasicTable?.data?.addressTypes?.length > 0 && (() => {
                  // Safely compute used address types outside the filter
                  const savedAddressesList = Array.isArray(addresses?.data) ? addresses.data : [];
                  const usedAddressTypeIds = savedAddressesList.map(
                    (addr) => addr?.address_type_id?.id
                  );

                  return (
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>
                        {"Address Type"}
                        <span className="redStreSpan">{"*"}</span>
                      </Form.Label>

                      <CustomSelectDropdown
                        style={{
                          chips: {
                            margin: 0,
                          },
                          multiselectContainer: {
                            backgroundColor: "#f8f8f8",
                          },
                          option: {
                            background: "#fbb040",
                            color: "#FFFFFF",
                            borderBottom: "1px solid #FFFFFF",
                          },
                        }}
                        options={bhareeAdminBasicTable?.data?.addressTypes?.filter((el) => {
                          // Hide already used address types only in create mode
                          if (!isUpdateMode && usedAddressTypeIds.includes(el.id)) {
                            return false;
                          }

                          // Existing role-based filtering logic
                          if (auth?.user?.role?.role_name === "BUYER") {
                            return el.type_name === "Delivery" || el.type_name === "Billing";
                          } else if (auth?.user?.role?.role_name === "SELLER") {
                            if (auth?.user?.roles_type?.role_type_name === "MANUFACTURER") {
                              return (
                                el.type_name === "Warehouse" ||
                                el.type_name === "Billing" ||
                                el.type_name === "Factory"
                              );
                            } else if (auth?.user?.roles_type?.role_type_name === "DISTRIBUTOR") {
                              return el.type_name === "Warehouse" || el.type_name === "Billing";
                            }
                          }
                          return true;
                        })}
                        onSelect={(e) => {
                          onSelectValue("address_type_id", e[0]);
                          if (e[0].type_name === "Factory") {
                            onSelectValue("set_default", true);
                          } else {
                            onSelectValue("set_default", false);
                          }
                        }}
                        selectedValues={
                          Object.prototype.hasOwnProperty.call(uploadFormObj, "address_type_id")
                            ? [uploadFormObj?.address_type_id]
                            : []
                        }
                        displayValue={"type_name"}
                        disable={isUpdateMode ? true : false}
                        singleSelect
                      />
                    </Form.Group>
                  );
                })()}
                

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Address Line 1"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={uploadFormObj?.address_line_1 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_1", e.target.value, 100)}
                />
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "address_line_1") && (
                    <p className="error-msg">{erroeMsg.address_line_1}</p>
                  )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Address Line 2"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.address_line_2 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_2", e.target.value, 100)}
                />
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "address_line_2") && (
                    <p className="error-msg">{erroeMsg.address_line_2}</p>
                  )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>{"Address Line 3"}</Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.address_line_3 || ""}
                  onChange={(e) => onSelectValueValidation("address_line_3", e.target.value, 100)}
                />
                {!isEmpty(erroeMsg) &&
                  Object.prototype.hasOwnProperty.call(erroeMsg, "address_line_3") && (
                    <p className="error-msg">{erroeMsg.address_line_3}</p>
                  )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail" style={{ display: "none" }}>
                <Form.Label>
                  {"Country"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                {!isEmpty(countries?.data) && countries.data?.length > 0 && (
                  <CustomSelectDropdown
                    style={{
                      chips: {
                        margin: 0,
                      },
                      multiselectContainer: {
                        backgroundColor: "#f8f8f8",
                      },
                      option: {
                        background: "#fbb040",
                        color: "#FFFFFF",
                        borderBottom: "1px solid #FFFFFF",
                      },
                    }}
                    options={countries?.data}
                    onSelect={(e) => onSelectValue("country", e[0].name)}
                    selectedValues={
                      Object.prototype.hasOwnProperty.call(uploadFormObj, "country")
                        ? FilterObjectsByKeyValue(countries.data, "name", uploadFormObj?.country)
                        : []
                    }
                    displayValue={"name"}
                    disable
                    singleSelect
                  />
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"State"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Select
                  value={stateName ? { value: stateName, label: stateName } : null}
                  onChange={(selected) => {
                    setStateName(selected?.value || "");
                    onSelectValue("state", selected?.value || "");
                    getGeoDataDB(selected?.value);
                    setDistrictName("");
                    setCity("");
                    setAreaName("");
                    setPinCode("");
                    if (selected?.value !== "") {
                      setErroeMsg("");
                    }
                  }}
                  options={statesList.map((s) => ({
                    value: s.state_name,
                    label: s.state_name,
                  }))}
                  placeholder="-- Select State --"
                  isSearchable={true}
                  className="react-select-container"
                  classNamePrefix="react-select-address"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  District <span className="text-danger">*</span>
                </Form.Label>
                <Select
                  value={districtName ? { value: districtName, label: districtName } : null}
                  onChange={(selected) => {
                    setDistrictName(selected?.value || "");
                    onSelectValue("district", selected?.value || "");
                    getGeoDataDB(stateName, selected?.value);
                    setCity("");
                    setAreaName("");
                    setPinCode("");
                  }}
                  options={districtList.map((d) => ({
                    value: d.district_name,
                    label: d.district_name,
                  }))}
                  placeholder="-- Select District --"
                  isSearchable={true}
                  className="react-select-container"
                  classNamePrefix="react-select-address"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"City"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Select
                  value={city ? { value: city, label: city } : null}
                  onChange={(selected) => {
                    setCity(selected?.value || "");
                    getGeoDataDB(stateName, districtName, selected?.value);
                    onSelectValue("city", selected?.value || "");
                    setAreaName("");
                    setPinCode("");
                  }}
                  options={cityList.map((c) => ({
                    value: c.city_name,
                    label: c.city_name,
                  }))}
                  placeholder="-- Select City --"
                  isSearchable={true}
                  className="react-select-container"
                  classNamePrefix="react-select-address"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  {"Area"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Select
                  value={areaName ? { value: areaName, label: areaName } : null}
                  onChange={(selected) => {
                    console.log("Area Selected: ", selected);
                    setAreaName(selected?.value || "");
                    onSelectValue("area", selected?.value || "");
                    const selectedAreaObj = areaData.find((el) => el.area === selected?.value);
                    setPinCode(selectedAreaObj?.pincode || "");
                    onSelectValue("pin_code", selectedAreaObj?.pincode || "");
                  }}
                  options={areaData.map((c) => ({
                    value: c.area,
                    label: c.area,
                  }))}
                  placeholder="-- Select Area --"
                  isSearchable={true}
                  className="react-select-container"
                  classNamePrefix="react-select-address"
                />
              </Form.Group>

              <p style={{ marginBottom: "10px" }}>Pin Code: {pinCode}</p>

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Check
                  type="checkbox"
                  name="radio_type"
                  checked={uploadFormObj?.set_default || false}
                  label={"Set default"}
                  className="square-checkbox"
                  onChange={(e) =>
                    onSelectValue(
                      "set_default",
                      Object.prototype.hasOwnProperty.call(uploadFormObj, "set_default")
                        ? !uploadFormObj.set_default
                        : true
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="action-buttons">
            {!addresses?.data?.length < 1 && (
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => setIsCreateMode(false)}
                disabled={requestCall?.loading}
              >
                {"Close"}
              </CustomButton>
            )}

            <CustomButton
              variant="primary"
              buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
              type="submit"
              loading={requestCall?.loading}
            >
              {!isUpdateMode ? "create" : "update"}
            </CustomButton>
          </div>
        </Form>
      </Row>
    </>
  );

  return (
    <Container fluid className="p-0 mb-3">
      {DialogModal}
      {(() => {
        if (!isCreateMode) {
          if (addresses?.data?.length > 0 && !addresses?.loading) {
            return (
              <Row className="address m-0">
                <Row className="heading-div ">
                  <h5 className="text-uppercase">{"Address"}</h5>
         <p
    style={{ cursor: "pointer" }}
    onClick={handleAddNewAddress}
  >
    {"+ Add"}
  </p>
                </Row>
                <hr />
                {addresses?.data.map((address) => {
                  return (
                    <Row className="m-0 p-0 mt-3">
                      <Col xs={10} className="form-col left">
                        <h6 className="text-uppercase">{address.address_type_id.type_name}</h6>
                        <p>
                          <span>{"Full Name:"}</span>
                          <span className="mx-2 bold-span"> {address.full_name}</span>
                        </p>
                        <p>
                          {address.address_line_1} {address.address_line_2} {address.address_line_3}
                        </p>
                        <p>
                          <span>{"Primary number:"}</span>
                          <span className="mx-2 bold-span">{address.primary_number}</span>
                          {!isEmpty(address.alternate_number) ? (
                            <>
                              {"|| "}
                              <span>{"Alternate number: "}</span>
                              <span className="mx-2 bold-span">{address.alternate_number}</span>
                            </>
                          ) : null}
                        </p>

                        <p>
                          <span>{"City:"}</span>
                          <span className="mx-2 bold-span"> {address.city}</span>
                          <span>{"Pin Code:"}</span>
                          <span className="mx-2 bold-span">{address.pin_code}</span>
                          <span>{"Area:"}</span>
                          <span className="mx-2 bold-span">{address.area}</span>
                        </p>
                        <p>
                          <span>{"State:"}</span>
                          <span className="mx-2 bold-span">{address.state}</span>
                          <span>{"Country:"}</span>
                          <span className="mx-2 bold-span">{address.country}</span>
                        </p>
                      </Col>
                      <Col xs={2} className="form-col right">
                        <div className="action-button-box">
                          {/* {brandModal("icon-action-btn", <EditIcon />, row.original)} */}
                          <CustomButton
                            buttonClasses="icon-action-btn"
                            onClick={() => {
                              // setIsCreateMode(true);
                              // setIsUpdateMode(true)
                              // setCurrentUpdateId(address?.id);
                              // setUploadFormObj(address);
                              onSetUpdateObj(address);
                            }}
                          >
                            <EditIcon />
                          </CustomButton>
                          <CustomButton
                            buttonClasses="icon-action-btn"
                            onClick={() => deleteAddress(address, dispatch, confirm)}
                          >
                            <DeleteIcon />
                          </CustomButton>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
            );
          } else if (addresses?.data?.length < 1 && !addresses?.loading) {
            return addressForm;
          } else if (addresses?.loading) {
            return <Spinner />;
          }
        } else if (isCreateMode) {
          return addressForm;
        }
      })()}
    </Container>
  );
};

export default Address;